'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _InstagramIcon = require('./InstagramIcon');

var _InstagramIcon2 = _interopRequireDefault(_InstagramIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _InstagramIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/InstagramIcon/index.js
// module id = 594
// module chunks = 11